import o,{css as s}from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as e}from"../../../theme/index.js";const t=o.div`
    ${o=>o.scroll&&s`
        overflow-y: scroll;

        ${e.theme.mixin.scroll}
      `};
  }
`;t.defaultProps=e;export{t as ContentContainer};
